import dayjs, { unix } from "dayjs";
import { jwtDecode } from "jwt-decode";

export function getTokenExpirationDate(token: string) {
  const result = jwtDecode(token);

  if (!result.exp) return undefined;

  return unix(result.exp);
}

export function isTokenExpired(token: string) {
  const expirationDate = getTokenExpirationDate(token);

  if (!expirationDate) return false;
  const now = dayjs().add(1, "minute");

  return expirationDate.isBefore(now);
}
